module.exports = __webpack_public_path__ + "static/media/AC.9838a4ba.svg";